import axios from 'axios';
import { useEffect, useState } from 'react';
import { Apis, BaseUrl } from '../../../redux/config';
import { getSession } from '../../../redux/actions/authActions';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

export const AddMoney = () => {
  const [amount, setAmount] = useState('');
  const [isRecurring, setIsRecurring] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const {
    recurringTypes,
    isLoadingRecurringTypes,
    activeSubscription,
    isLoadingSubscriptions,
  } = useSelector((state) => state.wallet);
  // const [recurringData, setRecurringData] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});

  const { user_profile_id, token } = getSession();

  const handleAddFunds = async (e) => {
    e.preventDefault();
    setIsRedirecting(true);
    const postData = isRecurring
      ? {
          user_profile_id,
          order_tot_amt: selectedOption.amount,
          transaction_source: 'recurring',
          price_id: selectedOption.price_id,
        }
      : {
          user_profile_id,
          transaction_type: 'credit',
          order_tot_amt: amount,
          transaction_source: 'one_time',
        };

    try {
      const response = await axios.post(
        `${BaseUrl}${Apis.createWalletTransaction}`,
        postData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      response.data.session_url
        ? (window.location.href = response.data.session_url)
        : toast.error(response.data.message);
    } catch (error) {
      toast.error(
        error.response?.data?.usr?.message ||
          error.response?.data?.message ||
          error.response?.message ||
          error.message
      );
    } finally {
      setIsRedirecting(false);
    }
  };

  useEffect(() => {
    setSelectedOption(recurringTypes[0]);
  }, [recurringTypes]);

  return (
    <div className="p-3 md:p-4">
      <h2 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">Add Money</h2>
      <div className="flex items-center mb-3 md:mb-4">
        <input
          disabled={activeSubscription || isLoadingSubscriptions}
          type="checkbox"
          id="recurring"
          className="mr-2"
          checked={isRecurring}
          onChange={() => setIsRecurring(!isRecurring)}
        />
        <label
          htmlFor="recurring"
          className={
            activeSubscription || isLoadingSubscriptions
              ? '!text-[#d0a8a8] cursor-not-allowed'
              : ''
          }
        >
          Activate My eWallet Subscription{' '}
          {(activeSubscription || isLoadingSubscriptions) && '(Already active)'}
        </label>
      </div>

      {isRecurring ? (
        isLoadingRecurringTypes ? (
          <div className="my-4 flex items-center w-fit gap-2">
            <Spinner animation="border" variant="primary" /> Loading Payment
            Options
          </div>
        ) : (
          <div className="flex gap-4">
            {recurringTypes.map((option) => (
              <label
                key={option.id}
                className="flex items-center gap-2 cursor-pointer mb-4 mt-2 !text-base"
              >
                <input
                  type="radio"
                  name="paymentMethod"
                  value={option.price_id}
                  checked={selectedOption.price_id === option.price_id}
                  onChange={() => setSelectedOption(option)}
                />
                ${option.amount} {option.frequency}
              </label>
            ))}
          </div>
        )
      ) : (
        <input
          type="number"
          placeholder="Enter Amount to add to eWallet"
          className="p-2 border rounded w-full mb-4"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
      )}
      <button
        className={`text-white px-4 py-2 rounded ${
          isRedirecting
            ? '!cursor-not-allowed bg-blue-300'
            : 'bg-blue-600 !cursor-pointer'
        }`}
        onClick={handleAddFunds}
      >
        {isRedirecting ? (
          <>
            <Spinner /> Redirecting to payment gateway
          </>
        ) : isRecurring ? (
          'Setup Recurring Payment'
        ) : (
          'Add Cash to eWallet'
        )}
      </button>
    </div>
  );
};
